// extracted by mini-css-extract-plugin
module.exports = {"root":"Wizard_root__2sohi","formWizard":"Wizard_formWizard__1Dn7W","wizardNavigation":"Wizard_wizardNavigation__3mb33","stepBody":"Wizard_stepBody__zxgHc"};